import React, { useRef } from 'react';

import { MainContentRefContext } from '@/routes/context/MainContentRefContext';

export const MainContentRefProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const mainContentRef = useRef<HTMLDivElement>(null);
    return (
        <MainContentRefContext.Provider value={mainContentRef}>
            {children}
        </MainContentRefContext.Provider>
    );
};

// No re-export needed, already exported above
